export default function login(AdminID, adminToken) {
  window.localStorage.setItem("X-Admin-Token", adminToken);
  window.localStorage.setItem("X-Auth-AdminID", AdminID);
}
